module.exports = __webpack_public_path__ + "img/list.8bc7c09a.png";